import { useFormContext } from 'react-hook-form';
import { WithAccountId } from '@mews-commander/types';
import { PaymentRequestType, PaymentRequestFormField, PaymentRequestFormValues } from './schema';
import { CollectPaymentFormFields } from './fields/CollectPaymentFormFields';
import { CollectPaymentMethodFormFields } from './fields/CollectPaymentMethodFormFields';
import { PreauthorizePaymentFormFields } from './fields/PreauthorizePaymentFormFields';

export const PaymentRequestTypeSelection = ({ accountId }: WithAccountId) => {
    const { watch } = useFormContext<PaymentRequestFormValues>();

    const type = watch(PaymentRequestFormField.Type);

    switch (type) {
        case PaymentRequestType.PaymentMethod:
            return <CollectPaymentMethodFormFields accountId={accountId} />;
        case PaymentRequestType.Payment:
            return <CollectPaymentFormFields accountId={accountId} />;
        case PaymentRequestType.Preauthorization:
            return <PreauthorizePaymentFormFields accountId={accountId} />;
        default:
            return null;
    }
};
